import { MUSCLE_GROUPS_TO_MUSCLES } from '../../../../muscles'
import { getMusclesExerciseUtil } from '../get-muscles'
import { getSecondaryMusclesExerciseUtil } from '../get-secondary-muscles'

export function getMuscleUsageMapExerciseUtil (obj) {
  const muscles = getMusclesExerciseUtil(obj)
  const secondaryMuscles = getSecondaryMusclesExerciseUtil(obj)
  const muscleUsageMap = muscles.reduce((obj, key) => {
    const muscles = MUSCLE_GROUPS_TO_MUSCLES[key] || [key]
    muscles.forEach(muscle => {
      obj[muscle] = 1
    })
    return obj
  }, {})
  secondaryMuscles.forEach(key => {
    muscleUsageMap[key] = 0.2
  })
  return muscleUsageMap
}
